import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { ChatStatusResponse } from '../../../models/chat-response.model';

@Component({
  selector: 'lib-chat-status-response-message',
  templateUrl: './chat-status-response-message.component.html',
  styleUrls: ['./chat-status-response-message.component.scss'],
  standalone: false
})
export class ChatStatusResponseMessageComponent implements OnChanges, OnDestroy {
  @Input() response!: ChatStatusResponse;
  @Input() rowIndex!: number;

  displayedText: string = '';
  isTyping: boolean = false;

  private typingIntervalId?: ReturnType<typeof setInterval>;
  private readonly typingSpeedMs = 30;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['response'] || changes['rowIndex']) {
      this.startTyping();
    }
  }

  ngOnDestroy(): void {
    this.stopTyping();
  }

  private startTyping(): void {
    this.stopTyping();

    const statusText = this.response?.data ?? '';
    const text = `${this.rowIndex + 1}. ${statusText}`;

    if (!statusText) {
      this.displayedText = '';
      this.isTyping = false;
      return;
    }

    let currentIndex = 0;
    this.isTyping = true;
    this.displayedText = '';

    this.typingIntervalId = setInterval(() => {
      currentIndex += 1;
      this.displayedText = text.slice(0, currentIndex);

      if (currentIndex >= text.length) {
        this.stopTyping();
        this.displayedText = text;
      }
    }, this.typingSpeedMs);
  }

  private stopTyping(): void {
    if (this.typingIntervalId) {
      clearInterval(this.typingIntervalId);
      this.typingIntervalId = undefined;
    }

    this.isTyping = false;
  }
}
